// 확장자 → mago-3d-tiler 입력 타입(-it) 매핑. mago-3d-tiler --help 기준으로 실제 인정되는 값만 매핑한다
// (kml, 3ds, fbx, obj, gltf/glb, las/laz, citygml, indoorgml, shp, geojson, gpkg).
// dae/ifc/ply 는 포맷 자체는 지원되지만 문서화된 -it 값이 아니므로 'auto'로 남겨 타일러의 자체 자동 감지에 맡긴다.
// TilerService.EXT_TO_INPUT_TYPE 과 대응되는 프론트 측 추정값.
const EXT_TO_INPUT_TYPE: Record<string, string> = {
  obj: 'obj',
  '3ds': '3ds',
  fbx: 'fbx',
  gltf: 'gltf',
  glb: 'gltf',
  las: 'las',
  laz: 'las',
  gml: 'citygml',
  shp: 'shp',
  geojson: 'geojson',
  gpkg: 'gpkg',
  kml: 'kml',
}

export function detectInputTypeFromFileName(fileName: string): string {
  const ext = fileName.toLowerCase().split('.').pop() ?? ''
  return EXT_TO_INPUT_TYPE[ext] ?? 'auto'
}

// 여러 파일(폴더 업로드) 중 알려진 확장자를 가진 첫 파일 기준으로 입력 타입을 추정
export function detectInputTypeFromFiles(files: File[]): string {
  for (const f of files) {
    const detected = detectInputTypeFromFileName(f.name)
    if (detected !== 'auto') return detected
  }
  return 'auto'
}

// 입력 타입에 따라 mago-3d-tiler 가 지원하는 출력 타입(-ot)을 자동으로 결정
export function recommendOutputType(inputType: string): 'b3dm' | 'i3dm' | 'pnts' {
  if (inputType === 'las') return 'pnts'
  if (inputType === 'kml') return 'i3dm'
  return 'b3dm'
}

// -qt(Mesh Quantization, KHR_mesh_quantization)는 glTF 메시 전용 — 포인트 클라우드(pnts) 출력에는 적용되지 않음
export function supportsQuantize(outputType: string): boolean {
  return outputType !== 'pnts'
}
